"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.moduleDriverUiComponentRegistry = void 0;
const _contracts_1 = require("./_contracts");
const ui_1 = require("./About/ui");
const ui_2 = require("./AdBanner/ui");
const ui_3 = require("./ArticleTeaser/ui");
const ui_4 = require("./ArticlesList/ui");
const ui_5 = require("./AuthorCard/ui");
const ui_6 = require("./Blockquote/ui");
const ui_7 = require("./Boxes/ui");
const ui_8 = require("./Contact/ui");
const ui_9 = require("./EditorialOffice/ui");
const ui_10 = require("./Embed/ui");
const ui_11 = require("./Experts/ui");
const ui_12 = require("./Gallery/ui");
const ui_13 = require("./HR/ui");
const ui_14 = require("./HTML/ui");
const ui_15 = require("./Heading/ui");
const ui_16 = require("./HeadingCountdown/ui");
const ui_17 = require("./Hero/ui");
const ui_18 = require("./Image/ui");
const ui_19 = require("./InfoBar/ui");
const ui_20 = require("./Legacy/ui");
const ui_21 = require("./List/ui");
const ui_22 = require("./LiveFeed/ui");
const ui_23 = require("./Logos/ui");
const ui_24 = require("./NewsBar/ui");
const ui_25 = require("./Newsletter/ui");
const ui_26 = require("./Pagination/ui");
const ui_27 = require("./Paragraph/ui");
const ui_28 = require("./Partners/ui");
const ui_29 = require("./Paywall/ui");
const ui_30 = require("./Quotes/ui");
const ui_31 = require("./ReadMore/ui");
const ui_32 = require("./RelatedArticles/ui");
const ui_33 = require("./RequestAccess/ui");
const ui_34 = require("./StickyBar/ui");
const ui_35 = require("./TeaserBox/ui");
const ui_36 = require("./Testimonials/ui");
const ui_37 = require("./Tile/ui");
const ui_38 = require("./DataSet/ui");
const RandomImage_ui_1 = require("./RandomImage/RandomImage.ui");
/**
 * Registry that binds the `ModuleDriver` with the corresponding module's UI component.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.moduleDriverUiComponentRegistry = {
    [_contracts_1.ModuleDriver.About]: ui_1.AboutModuleUi,
    [_contracts_1.ModuleDriver.AdBanner]: ui_2.AdBannerModuleUi,
    [_contracts_1.ModuleDriver.ArticleTeaser]: ui_3.ArticleTeaserModuleUi,
    [_contracts_1.ModuleDriver.ArticlesList]: ui_4.ArticlesListModuleUi,
    [_contracts_1.ModuleDriver.AuthorCard]: ui_5.AuthorCardModuleUi,
    [_contracts_1.ModuleDriver.Blockquote]: ui_6.BlockquoteModuleUi,
    [_contracts_1.ModuleDriver.Boxes]: ui_7.BoxesModuleUi,
    [_contracts_1.ModuleDriver.Contact]: ui_8.ContactModuleUi,
    [_contracts_1.ModuleDriver.DataSet]: ui_38.DataSetModuleUi,
    [_contracts_1.ModuleDriver.EditorialOffice]: ui_9.EditorialOfficeModuleUi,
    [_contracts_1.ModuleDriver.Embed]: ui_10.EmbedModuleUi,
    [_contracts_1.ModuleDriver.Experts]: ui_11.ExpertsModuleUi,
    [_contracts_1.ModuleDriver.Gallery]: ui_12.GalleryModuleUi,
    [_contracts_1.ModuleDriver.HR]: ui_13.HRModuleUi,
    [_contracts_1.ModuleDriver.HTML]: ui_14.HTMLModuleUi,
    [_contracts_1.ModuleDriver.Heading]: ui_15.HeadingModuleUi,
    [_contracts_1.ModuleDriver.HeadingCountdown]: ui_16.HeadingCountdownModuleUi,
    [_contracts_1.ModuleDriver.Hero]: ui_17.HeroModuleUi,
    [_contracts_1.ModuleDriver.Image]: ui_18.ImageModuleUi,
    [_contracts_1.ModuleDriver.InfoBar]: ui_19.InfoBarModuleUi,
    [_contracts_1.ModuleDriver.Legacy]: ui_20.LegacyModuleUi,
    [_contracts_1.ModuleDriver.List]: ui_21.ListModuleUi,
    [_contracts_1.ModuleDriver.LiveFeed]: ui_22.LiveFeedModuleUi,
    [_contracts_1.ModuleDriver.Logos]: ui_23.LogosModuleUi,
    [_contracts_1.ModuleDriver.NewsBar]: ui_24.NewsBarModuleUi,
    [_contracts_1.ModuleDriver.Newsletter]: ui_25.NewsletterModuleUi,
    [_contracts_1.ModuleDriver.Pagination]: ui_26.PaginationModuleUi,
    [_contracts_1.ModuleDriver.Paragraph]: ui_27.ParagraphModuleUi,
    [_contracts_1.ModuleDriver.Partners]: ui_28.PartnersModuleUi,
    [_contracts_1.ModuleDriver.Paywall]: ui_29.PaywallModuleUi,
    [_contracts_1.ModuleDriver.Quotes]: ui_30.QuotesModuleUi,
    [_contracts_1.ModuleDriver.RandomImage]: RandomImage_ui_1.RandomImageModuleUi,
    [_contracts_1.ModuleDriver.ReadMore]: ui_31.ReadMoreModuleUi,
    [_contracts_1.ModuleDriver.RelatedArticles]: ui_32.RelatedArticlesModuleUi,
    [_contracts_1.ModuleDriver.RequestAccess]: ui_33.RequestAccessModuleUi,
    [_contracts_1.ModuleDriver.StickyBar]: ui_34.StickyBarModuleUi,
    [_contracts_1.ModuleDriver.TeaserBox]: ui_35.TeaserBoxModuleUi,
    [_contracts_1.ModuleDriver.Tile]: ui_37.TileModuleUi,
    [_contracts_1.ModuleDriver.Testimonials]: ui_36.TestimonialsModuleUi
};
//# sourceMappingURL=driver-component.registry.ui.js.map